<div class="step cursor-pointer my-3 text-gray-500 fadeInOnEnter delay-300" [class.text-gray-700]="newsletter" (click)="toggle()">
  <i class="far fa-{{ newsletter ? 'check-square' : 'square'}}"></i>
  <span class="text-xs ml-2" [translate]="newsletter ? 'PAGE_COMBIPACKAGE_NEWSLETTER_YES' : 'PAGE_COMBIPACKAGE_NEWSLETTER_NO'"></span>
</div>
